import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

const CommonTable = ({
  columns,
  dataSource,
  loading = false,
  pagination = {},
  className = '',
  ...rest
}) => {
  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      loading={loading}
      pagination={pagination}
      className={`common-table ${className}`}
      rowKey={(record) => record.id || record.key}
      {...rest}
    />
  );
};

CommonTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.object).isRequired,
  loading: PropTypes.bool,
  pagination: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
  className: PropTypes.string,
};

export default CommonTable;